import renderWrapper from './render-wrapper';
import MiniCart from '../Components/MiniCart/MiniCart';
import MiniCartButton from '../Components/MiniCart/MiniCartButton';
import StockStatus from '../Components/StockStatus/StockStatus';
import Checkout from '../Components/Checkout/Checkout';
import ProductFiltering from '../Components/ProductFiltering/ProductFiltering';
import ProductSorting from '../Components/ProductSorting/ProductSorting';
import BuyButton from '../Components/BuyButton/BuyButton';
import FilterBar from '../Components/FilterBar/FilterBar';
import MyPagesContainer from '../Components/MyPages/MyPagesContainer';
import Navigation from '../Components/Navigation/Navigation';
import ProductPageImageSlider from '../Components/ProductPageImageSlider/ProductPage.ImageSlider';
import BannerSliderBlock from '../Blocks/BannerBlock/BannerSliderBlock';
import BannerBlock from '../Blocks/BannerBlock/BannerBlock';
import ProductListHeaderText from '../Components/ProductList.HeaderText';
import ActiveFilterChips from '../Components/ActiveFilterChips/ActiveFilterChips';
import ProductBlock from '../Blocks/ProductBlock';
import QuickSearch from '../Components/QuickSearch/QuickSearch';
import SearchResult from '../Components/SearchResult/SearchResult';
import SearchNavigation from '../Components/SearchResult/SearchNavigation';
import NavigationMobileTrigger from '../Components/Navigation/NavigationMobileTrigger';
import NavigationMobile from '../Components/Navigation/NavigationMobile';
import Overlay from '../Components/Overlay';
import VariantPickerDropdown from '../Components/VariantPicker/VariantPicker.Dropdown';
import VariantPickerButtons from '../Components/VariantPicker/VariantPicker.Buttons';
import LoginModal from '../Components/Login/LoginModal';
import LoginPage from '../Components/Login/LoginPage';
import LoginModalTrigger from '../Components/Login/LoginModalTrigger';
import ProductListing from '../Components/ProductListing/ProductListing';
import PriceHistoryModalTrigger from '../Components/ProductPriceHistory/PriceHistoryModalTrigger';
import OrderConfirmation from '../Components/OrderConfirmation/OrderConfirmation';
import BrandsBlock from '../Blocks/BrandsBlock';
import EditorString from '../Components/EditorString/EditorString';
import RichTextBlock from '../Blocks/RichTextBlock';
import TopMessage from '../Components/TopMessage/TopMessage';
import FaqAccordion from '../Blocks/FaqAccordion';
import ResponsiveImage from '../Components/ResponsiveImage/ResponsiveImage';
import UspBlock from '../Blocks/UspBlock';
import ScrollToElementButton from '../Components/ScrollToElementButton/ScrollToElementButton';
import SubNavigationContainer from '../Components/SubNavigationContainer/SubNavigationContainer';
import ProductsAndBannerBlock from '../Blocks/ProductsAndBannerBlock';
import CookieConsent from '../Components/CookieConsent/CookieConsent';
import PriceHistoryModal from '../Components/ProductPriceHistory/PriceHistoryModal';
import CategoryNavigation from '../Components/ProductListing/CategoryNavigation';
import TopMenuUsps from '../Components/TopMenuUsps/TopMenuUsps';
import QuickSearchTrigger from '../Components/QuickSearch/QuickSearchTrigger';
import NewsletterRegistration from '../Components/NewsletterRegistration/NewsletterRegistration';
import MediaBlockProductsButton from '../Components/MediaBlockProductsButton/MediaBlockProductsButton';
import ProductPrice from '../Components/ProductPrice/ProductPrice';
import CustomResponsiveSlider from '../Components/CustomResponsiveSlider/CustomResponsiveSlider';
import PageCardBlock from '../Blocks/PageCardBlock';
import NewsList from '../Components/NewsList/NewsList';
import ProductPage from '../Components/ProductPage/ProductPage';
import MeasuredWallpaperProductPage from '../Components/ProductPage/MeasuredWallpaperProductPage';
import MegaMenuBlock from '../Blocks/MegaMenuBlock';
import MobileProductCountBar from '../Components/FilterBar/MobileProductCountBar';
import MobileStickyFilterBar from '../Components/FilterBar/MobileStickyFilterBar';
import LanguageSelectDesktopContainer from '../Components/LanguageSelect/LanguageSelectDesktopContainer';
import RegisterUserPage from '../Components/Login/RegisterUserPage';
import CollectionStore from '../Components/CollectionStore/CollectionStore';
import WallpaperCalculator from '../Components/WallpaperCalculator/WallpaperCalculator';
import RetailerListContainer from '../Components/RetailerList/RetailerListContainer';
import ContactForm from '../Blocks/ContactForm';
import ToastContainer from '../Components/Toast/ToastContainer';
import WallpaperSimulatorContainer from '../Components/WallpaperSimulator/WallpaperSimulatorContainer';
import QuickOrder from '../Components/QuickOrder/QuickOrder';
import WishList from '../Components/WishList/WishList';
import SubNavigationList from '../Components/SubNavigationContainer/SubNavigationList';
import StickyStoreNavigation from '../Components/Navigation/StickyStoreNavigation';
import LoggedInIconAndDropdown from '../Components/MyPages/LoggedInIconAndDropdown';
import PriceToggle from '../Components/PriceToggle/PriceToggle';
import MeasuredWallpaperStandalone from '../Components/MeasuredWallpaperStandalone/MeasuredWallpaperStandalone';
import CheckoutStoreScreenContainer from '../Components/Checkout/StoreScreen/Checkout.StoreScreenContainer';
import FileListBlock from '../Blocks/FileListBlock';

global['Components'] = {
  ProductListing: (props) => renderWrapper(ProductListing, props),
  MiniCart: (props) => renderWrapper(MiniCart, props),
  MiniCartButton: (props) => renderWrapper(MiniCartButton, props),
  StockStatus: (props) => renderWrapper(StockStatus, props),
  ProductFiltering: (props) => renderWrapper(ProductFiltering, props),
  ProductSorting: (props) => renderWrapper(ProductSorting, props),
  MyPagesContainer: (props) => renderWrapper(MyPagesContainer, props),
  Checkout: (props) => renderWrapper(Checkout, props),
  BuyButton: (props) => renderWrapper(BuyButton, props),
  FilterBar: (props) => renderWrapper(FilterBar, props),
  QuickSearch: (props) => renderWrapper(QuickSearch, props),
  SearchResult: (props) => renderWrapper(SearchResult, props),
  SearchNavigation: (props) => renderWrapper(SearchNavigation, props),
  ProductBlock: (props) => renderWrapper(ProductBlock, props),
  ProductListHeaderText: (props) =>
    renderWrapper(ProductListHeaderText, props),
  Navbar: (props) => renderWrapper(Navigation, props),
  ProductPageImageSlider: (props) =>
    renderWrapper(ProductPageImageSlider, props),
  BannerSliderBlock: (props) => renderWrapper(BannerSliderBlock, props),
  BannerBlock: (props) => renderWrapper(BannerBlock, props),
  ActiveFilterChips: (props) => renderWrapper(ActiveFilterChips, props),
  NavigationMobileTrigger: (props) =>
    renderWrapper(NavigationMobileTrigger, props),
  NavigationMobile: (props) => renderWrapper(NavigationMobile, props),
  Overlay: (props) => renderWrapper(Overlay, props),
  VariantPickerDropdown: (props) =>
    renderWrapper(VariantPickerDropdown, props),
  VariantPickerButtons: (props) =>
    renderWrapper(VariantPickerButtons, props),
  LoginModal: (props) => renderWrapper(LoginModal, props),
  LoginPage: (props) => renderWrapper(LoginPage, props),
  LoginModalTrigger: (props) => renderWrapper(LoginModalTrigger, props),
  TopMessage: (props) => renderWrapper(TopMessage, props),
  OrderConfirmation: (props) => renderWrapper(OrderConfirmation, props),
  ProductsAndBannerBlock: (props) =>
    renderWrapper(ProductsAndBannerBlock, props),
  BrandsBlock: (props) => renderWrapper(BrandsBlock, props),
  EditorString: (props) => renderWrapper(EditorString, props),
  RichTextBlock: (props) => renderWrapper(RichTextBlock, props),
  FaqAccordion: (props) => renderWrapper(FaqAccordion, props),
  UspBlock: (props) => renderWrapper(UspBlock, props),
  ResponsiveImage: (props) => renderWrapper(ResponsiveImage, props),
  ScrollToElementButton: (props) =>
    renderWrapper(ScrollToElementButton, props),
  SubNavigationContainer: (props) =>
    renderWrapper(SubNavigationContainer, props),
  CookieConsent: (props) => renderWrapper(CookieConsent, props),
  PriceHistoryModalTrigger: (props) =>
    renderWrapper(PriceHistoryModalTrigger, props),
  PriceHistoryModal: (props) => renderWrapper(PriceHistoryModal, props),
  CategoryNavigation: (props) => renderWrapper(CategoryNavigation, props),
  TopMenuUsps: (props) => renderWrapper(TopMenuUsps, props),
  QuickSearchTrigger: (props) => renderWrapper(QuickSearchTrigger, props),
  LanguageSelectDesktopContainer: (props) =>
    renderWrapper(LanguageSelectDesktopContainer, props),
  NewsletterRegistration: (props) =>
    renderWrapper(NewsletterRegistration, props),
  MediaBlockProductsButton: (props) =>
    renderWrapper(MediaBlockProductsButton, props),
  ProductPrice: (props) => renderWrapper(ProductPrice, props),
  CustomResponsiveSlider: (props) =>
    renderWrapper(CustomResponsiveSlider, props),
  PageCardBlock: (props) => renderWrapper(PageCardBlock, props),
  NewsList: (props) => renderWrapper(NewsList, props),
  ProductPage: (props) => renderWrapper(ProductPage, props),
  MeasuredWallpaperProductPage: (props) =>
    renderWrapper(MeasuredWallpaperProductPage, props),
  MegaMenuBlock: (props) => renderWrapper(MegaMenuBlock, props),
  MobileProductCountBar: (props) =>
    renderWrapper(MobileProductCountBar, props),
  MobileStickyFilterBar: (props) =>
    renderWrapper(MobileStickyFilterBar, props),
  RegisterUserPage: (props) => renderWrapper(RegisterUserPage, props),
  CollectionStore: (props) => renderWrapper(CollectionStore, props),
  RetailerListContainer: (props) =>
    renderWrapper(RetailerListContainer, props),
  WallpaperCalculator: (props) =>
    renderWrapper(WallpaperCalculator, props),
  ContactForm: (props) => renderWrapper(ContactForm, props),
  ToastContainer: (props) => renderWrapper(ToastContainer, props),
  WallpaperSimulatorContainer: (props) =>
    renderWrapper(WallpaperSimulatorContainer, props),
  QuickOrder: (props) => renderWrapper(QuickOrder, props),
  WishList: (props) => renderWrapper(WishList, props),
  SubNavigationList: (props) => renderWrapper(SubNavigationList, props),
  StickyStoreNavigation: (props) =>
    renderWrapper(StickyStoreNavigation, props),
  LoggedInIconAndDropdown: (props) =>
    renderWrapper(LoggedInIconAndDropdown, props),
  PriceToggle: (props) => renderWrapper(PriceToggle, props),
  MeasuredWallpaperStandalone: (props) =>
    renderWrapper(MeasuredWallpaperStandalone, props),
  CheckoutStoreScreenContainer: (props) =>
    renderWrapper(CheckoutStoreScreenContainer, props),
  FileListBlock: (props) => renderWrapper(FileListBlock, props),
};
